export default __webpack_public_path__ + "static/media/12_1.6c49f909.jpg";